'use client';

import { createReducer } from 'redux-act';
import { windowResized } from '../actions/browser';

const defaultState = {};

const reducer = createReducer(
  {
    [windowResized]: () => {
      if (typeof window === 'undefined') return {};
      const width = window.innerWidth;
      const height = window.innerHeight;

      const extraSmallBreakpoint = 479;
      const mediumBreakpoint = 767;
      const largeBreakpoint = 1023;
      const extraLargeBreakpoint = 1279;

      let viewportSize;
      if (width <= mediumBreakpoint) {
        viewportSize = 'small';
      } else if (width > mediumBreakpoint && width <= largeBreakpoint) {
        viewportSize = 'medium';
      } else if (width > largeBreakpoint && width <= extraLargeBreakpoint) {
        viewportSize = 'large';
      } else if (width > extraLargeBreakpoint) {
        viewportSize = 'extralarge';
      }
      // we'll need to remove the old isMobile and isTablet
      // when the new dashboard is fully complete
      return {
        innerWidth: width,
        innerHeight: height,
        isDesktop: width > extraLargeBreakpoint,
        isMobile: width <= mediumBreakpoint,
        isTablet: width <= 1024 && width > mediumBreakpoint,
        isSmallMobile: width <= extraSmallBreakpoint,
        isMobileOrSmallTablet: width <= extraLargeBreakpoint,
        isBigMobile: width <= largeBreakpoint && width > extraSmallBreakpoint,
        isAnyMobile: width <= largeBreakpoint,
        isSmallTablet: width <= extraLargeBreakpoint && width > largeBreakpoint,
        viewportSize,
      };
    },
  },
  defaultState,
);

export default reducer;
